<div class="page-container">
  <div class="top-header">
    <div class="left">
      <span class="back-arrow">
        <i class="bi bi-arrow-left" (click)="goToLinkPages()"></i>
      </span>
      <span class="back-text" (click)="goToLinkPages()">Back to links</span>
    </div>
  </div>

  <div class="card summary-card">
    <span class="section-label mt-3">ATTEMPTS</span>
    <div class="header-row">
      <div>
        <h2>{{ quizName || 'Assessment Attempts' }}</h2>
        <p class="subtitle">{{ linkName  }}</p>
        <p class="subtitle">Candidate results & proctoring overview</p>
      </div>

      <button class="view-btn" (click)="downloadViolations()">
        <i class="bi bi-download me-2"></i>
        Download Violations
      </button>
    </div>

    <!-- STATS -->
    <div class="stats-block">
      <div class="stat-item">
        <div class="icon purple">
          <i class="bi bi-people"></i>
        </div>
        <div>
          <h3>{{ totalAttempt }}</h3>
          <p>TOTAL ATTEMPTS</p>
        </div>
      </div>

      <div class="divider"></div>

      <div class="stat-item">
        <div class="icon green">
          <i class="bi bi-check-circle"></i>
        </div>
        <div>
          <h3 class="green-text">{{ passedAttempt }}</h3>
          <p>PASSED</p>
        </div>
      </div>

      <div class="divider"></div>

      <div class="stat-item">
        <div class="icon red">
          <i class="bi bi-x-circle"></i>
        </div>
        <div>
          <h3 class="red-text">{{ failedAttempt }}</h3>
          <p>FAILED</p>
        </div>
      </div>

      <div class="divider"></div>

      <div class="stat-item">
        <div class="icon purple">
          <i class="bi bi-graph-up"></i>
        </div>
        <div>
          <h3>{{ avgScore }}</h3>
          <p>AVG. SCORE</p>
        </div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <input
      type="text"
      placeholder="Search by name or email"
      (input)="onSearch($any($event.target).value)"
    />
    <div class="filters">
      <button (click)="setTab('ALL')" [class.active]="selectedTab === 'ALL'">
        All ({{ totalAttempt }})
      </button>

      <button
        (click)="setTab('PASSED')"
        [class.active]="selectedTab === 'PASSED'"
      >
        Passed ({{ passedAttempt }})
      </button>

      <button
        (click)="setTab('FAILED')"
        [class.active]="selectedTab === 'FAILED'"
      >
        Failed ({{ failedAttempt }})
      </button>
    </div>
  </div>

  <div class="card table-card">
    <table>
      <thead>
        <tr>
          <th>Candidate</th>
          <th>Score</th>
          <th>Status</th>
          <th>Violations</th>
          <th>Attempt</th>
          <th>Completed</th>
          <th>Action</th>
        </tr>
      </thead>

      <tbody>
  <tr *ngFor="let item of filteredData">
    <td>
      {{ item.candidate_name }} <br />
      <small>{{ item.candidate_email }}</small>
    </td>
    <td><small>{{ item.score_percentage }}</small></td>
    <td>
      <span class="badge" [ngClass]="{
        success: item.result?.toLowerCase() === 'passed',
        danger: item.result?.toLowerCase() === 'failed',
        info: item.result?.toLowerCase() === 'invited'
      }">
        {{ item.result }}
      </span>
    </td>
    <td>
      <span *ngIf="item.attempt_id" class="badge warn">{{ item.violations }}</span>
      <span *ngIf="!item.attempt_id" class="text-muted">—</span>
    </td>
    <td>
      <span *ngIf="item.attempt_id"> {{ item.attempt_number }}</span>
      <span *ngIf="!item.attempt_id" class="text-muted">—</span>
    </td>
    <td>{{ item.completed_at ? (item.completed_at | date: 'mediumDate') : 'Not Completed' }}</td>
    <td>
      <button *ngIf="item.attempt_id" class="view-btn" (click)="goToAssessmentReportPage(item.attempt_id)">
        <i class="bi bi-eye"></i> View Report
      </button>
      <span *ngIf="!item.attempt_id" class="text-muted">—</span>
    </td>
  </tr>

  <!-- Empty state -->
  <tr *ngIf="filteredData.length === 0">
    <td colspan="7" class="empty-state text-center">
      <i class="bi bi-inbox"></i>
      <p>
        <ng-container *ngIf="selectedTab === 'PASSED'">No passed attempts found.</ng-container>
        <ng-container *ngIf="selectedTab === 'FAILED'">No failed attempts found.</ng-container>
        <ng-container *ngIf="selectedTab === 'ALL'">No attempts found.</ng-container>
      </p>
    </td>
  </tr>
</tbody>

    </table>
  </div>
</div>
